import { resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-abeee234"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view w-100 h-100" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "search" }
const _hoisted_5 = { class: "price-channel-info" }
const _hoisted_6 = { class: "price-lines" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "coupon-info"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { class: "price-line-item-right" }
const _hoisted_13 = { class: "priceLineName" }
const _hoisted_14 = { class: "priceLine-info" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " ", -1))
const _hoisted_16 = {
  key: 0,
  class: "coupon-left-count"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 0,
  class: "show-all-products-div"
}
const _hoisted_19 = {
  key: 1,
  style: {"font-size":"24px"},
  class: "d-flex justify-content-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_view_header = _resolveComponent("view-header")!
  const _component_OrderHeaderChangeActions = _resolveComponent("OrderHeaderChangeActions")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_BackAndCancelFooter = _resolveComponent("BackAndCancelFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_view_header, {
      text: _ctx.product?.name ?? ''
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_OrderHeaderChangeActions, { productId: _ctx.productId }, null, 8, ["productId"]),
      (_ctx.priceListsToView && _ctx.slot)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_TextInput, {
                placeholder: _ctx.$t('cashier.placeholder.customer-type.search'),
                class: "col-7",
                clearable: true,
                modelValue: _ctx.priceSearchNumber,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.priceSearchNumber) = $event)),
                onKeypress: _withKeys(_ctx.onSearchEnterPress, ["enter"])
              }, null, 8, ["placeholder", "modelValue", "onKeypress"])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.priceListsToView, (priceList) => {
              return (_openBlock(), _createElementBlock("div", {
                key: priceList.productPriceId,
                class: "product-price-lines-main"
              }, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(priceList?.title ?? ""), 1),
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(priceList?.priceLines, (priceLine) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: priceLine.id,
                      class: _normalizeClass(["price-line-item", { 'price-line-item-with-coupon': priceLine.coupon, 'price-line-item-disabled' : _ctx.activePriceId !== null && _ctx.activePriceId !== priceList.id }]),
                      onClick: ($event: any) => (_ctx.selectPriceLine(priceLine, priceList.channelId, priceList.id, priceList.currencyId))
                    }, [
                      (priceLine.coupon)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.label.coupon")), 1),
                            (priceLine.coupon.discountPercent)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_9, "- " + _toDisplayString(priceLine.coupon.discountPercent) + " %", 1))
                              : _createCommentVNode("", true),
                            (priceLine.coupon.discountAmount)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_10, "- " + _toDisplayString(priceLine.coupon.discountAmount) + " " + _toDisplayString(priceLine.coupon.currencySymbol), 1))
                              : _createCommentVNode("", true),
                            (priceLine.coupon.ticketFixedUnitPrice)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_11, "= " + _toDisplayString(priceLine.coupon.ticketFixedUnitPrice) + " " + _toDisplayString(_ctx.currencySign(priceList.currencyId)), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("span", null, _toDisplayString(priceLine.name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.formatAmount(priceLine.priceForOne)), 1),
                          _hoisted_15,
                          _createElementVNode("span", null, _toDisplayString(_ctx.currencySign(priceList.currencyId)), 1)
                        ]),
                        (priceLine.coupon)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _createElementVNode("span", null, _toDisplayString(priceLine.coupon.limitationType ==
                            _ctx.couponLimitationType.TotalAmount
                            ? _ctx.formatAmount(priceLine.coupon.leftLimitationTotal)
                            : priceLine.coupon.leftLimitationTotal) + " ", 1),
                              (priceLine.coupon.limitationType == _ctx.couponLimitationType.TotalAmount)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(priceLine.coupon.currencySymbol), 1))
                                : _createCommentVNode("", true),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t("cashier.label.left")), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ], 10, _hoisted_7))
                  }), 128))
                ])
              ]))
            }), 128)),
            (_ctx.isClub)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showAllPriceLines && _ctx.showAllPriceLines(...args)))
                  }, _toDisplayString(_ctx.showClubMoreBtn
                ? _ctx.$t("cashier.btn.show-rest-customer-types")
                : _ctx.$t("cashier.btn.hide-rest-customer-types")), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.$t("cashier.no-relevant-price")), 1))
    ]),
    _createVNode(_component_BackAndCancelFooter, { clubId: _ctx.clubId }, null, 8, ["clubId"])
  ]))
}